import React from "react";
import { Box, Typography } from "@mui/material";

const Footer: React.FC = () => {
  return (
    <Box
      component="footer"
      sx={{
        py: { xs: 1, sm: 2 },
        textAlign: "center",
        backgroundColor: (theme) => theme.palette.background.paper,
        mt: "auto",
        borderTop: "1px solid",
        borderColor: "divider",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Typography variant="body2" color="textSecondary">
        © {new Date().getFullYear()} Admin Panel. All rights reserved.
      </Typography>
    </Box>
  );
};

export default Footer;
